/**
 * Internal dependencies
 */
import { updateFirstVisit } from './utils/segmentation/segmentation-settings';

void ( function (): void {
	updateFirstVisit();
} )();
